import { TeambookIcon } from "../../../default_images/TeambookIcon";
import { icons } from "../../../default_images/IconsList";

export const getTableHeader = (type, t) => {
  switch (type) {
    case "default":
      return [
        {
          cells: [
            { value: "", className: "teambook-table__user-cell" },
            { value: "" },
            { value: t("header.projects"), colspan: 4 },
            { value: t("dashboard.time_offs"), colspan: 2 },
            { value: "" },
          ],
        },
        {
          cells: [
            { value: "user_block", className: "teambook-table__user-cell" },
            { value: t("actuals.monthly_working"), sortingField: "working_hours" },
            { value: t("projects.billable"), style: { borderRight: 0 }, sortingField: "billable" },
            { value: t("planning.tentative"), sortingField: "tentative_billable" },
            { value: t("projects.non_billable"), style: { borderRight: 0 }, sortingField: "non_billable" },
            { value: t("planning.tentative"), sortingField: "tentative_non_billable" },
            { value: t("dashboard.real"), style: { borderRight: 0 }, sortingField: "time_off" },
            { value: t("planning.tentative"), sortingField: "tentative_time_off" },
            { value: t("dashboard.availability"), sortingField: "availability" },
          ],
        },
      ];
    case "actuals":
      return [
        {
          cells: [
            { value: "", className: "teambook-table__user-cell" },
            { value: "" },
            { value: t("header.projects"), colspan: 2 },
            { value: t("dashboard.time_offs") },
            { value: "" },
            { value: "" },
          ],
        },
        {
          cells: [
            { value: "user_block", className: "teambook-table__user-cell" },
            { value: t("actuals.monthly_working"), sortingField: "working_hours" },
            { value: t("projects.billable"), sortingField: "billable" },
            { value: t("projects.non_billable"), sortingField: "non_billable" },
            { value: t("dashboard.real"), sortingField: "time_off" },
            { value: t("dashboard.difference"), sortingField: "difference" },
            { value: t("actuals.approved"), sortingField: "approved" },
          ],
        },
      ];
    case "capacity":
      return [
        {
          cells: [
            { value: "", className: "teambook-table__user-cell" },
            { value: "" },
            { value: t("header.projects"), colspan: 2 },
            { value: t("dashboard.time_offs") },
            { value: "" },
          ],
        },
        {
          cells: [
            { value: "user_block", className: "teambook-table__user-cell" },
            { value: t("actuals.monthly_working"), sortingField: "working_hours" },
            { value: t("projects.billable"), sortingField: "billable" },
            { value: t("projects.non_billable"), sortingField: "non_billable" },
            { value: t("dashboard.real"), sortingField: "time_off" },
            { value: t("dashboard.availability"), sortingField: "availability" },
          ],
        },
      ];
    case "compare":
      return [
        {
          cells: [
            { value: "", className: "teambook-table__user-cell" },
            { value: "", className: "teambook-table__fixed-180" },
            { value: t("dashboard.billable_projects"), colspan: 3 },
            { value: t("dashboard.non_billable_projects"), colspan: 3 },
            { value: t("dashboard.time_offs"), colspan: 3 },
            { value: t("dashboard.total"), colspan: 3 },
          ],
        },
        {
          cells: [
            { value: "user_block", className: "teambook-table__user-cell" },
            {
              value: t("actuals.monthly_working"),
              sortingField: "working_hours",
              className: "teambook-table__fixed-180",
            },
            {
              value: <TeambookIcon name={icons.FILLED_CALENDAR} />,
              style: { borderRight: 0 },
              sortingField: "planned_billable",
            },
            { value: <TeambookIcon name={icons.HOURS} />, style: { borderRight: 0 }, sortingField: "actual_billable" },
            { value: <TeambookIcon name={icons.DELTA} />, sortingField: "diff_billable" },
            {
              value: <TeambookIcon name={icons.FILLED_CALENDAR} />,
              style: { borderRight: 0 },
              sortingField: "planned_non_billable",
            },
            {
              value: <TeambookIcon name={icons.HOURS} />,
              style: { borderRight: 0 },
              sortingField: "actual_non_billable",
            },
            { value: <TeambookIcon name={icons.DELTA} />, sortingField: "diff_non_billable" },
            {
              value: <TeambookIcon name={icons.FILLED_CALENDAR} />,
              style: { borderRight: 0 },
              sortingField: "planned_time_off",
            },
            { value: <TeambookIcon name={icons.HOURS} />, style: { borderRight: 0 }, sortingField: "actual_time_off" },
            { value: <TeambookIcon name={icons.DELTA} />, sortingField: "diff_time_off" },
            {
              value: <TeambookIcon name={icons.FILLED_CALENDAR} />,
              style: { borderRight: 0 },
              sortingField: "planned_total",
            },
            { value: <TeambookIcon name={icons.HOURS} />, style: { borderRight: 0 }, sortingField: "actual_total" },
            { value: <TeambookIcon name={icons.DELTA} />, sortingField: "difference" },
          ],
        },
      ];
  }
};

export const getTableContentRows = (stats, type) => {
  switch (type) {
    case "default":
      return stats[0].map((stat) => ({
        style: { height: "40px" },
        cells: [
          { value: "user_block", user: stat.user },
          { value: stat.working_hours, style: { textAlign: "center" }, sortingField: "working_hours" },
          { value: stat.billable, style: { textAlign: "center", borderRight: 0 }, sortingField: "billable" },
          { value: stat.tentative_billable, style: { textAlign: "center" }, sortingField: "tentative_billable" },
          { value: stat.non_billable, style: { textAlign: "center", borderRight: 0 }, sortingField: "non_billable" },
          {
            value: stat.tentative_non_billable,
            style: { textAlign: "center" },
            sortingField: "tentative_non_billable",
          },
          { value: stat.time_off, style: { textAlign: "center", borderRight: 0 }, sortingField: "time_off" },
          { value: stat.tentative_time_off, style: { textAlign: "center" }, sortingField: "tentative_time_off" },
          { value: stat.free, style: { textAlign: "center" }, sortingField: "availability" },
        ],
      }));
    case "actuals":
      return stats[0].map((stat) => ({
        style: { height: "40px" },
        cells: [
          { value: "user_block", user: stat.user },
          { value: stat.working_hours, style: { textAlign: "center" }, sortingField: "working_hours" },
          { value: stat.billable + stat.tentative_billable, style: { textAlign: "center" }, sortingField: "billable" },
          {
            value: stat.non_billable + stat.tentative_non_billable,
            style: { textAlign: "center" },
            sortingField: "non_billable",
          },
          { value: stat.time_off + stat.tentative_time_off, style: { textAlign: "center" }, sortingField: "time_off" },
          { value: stat.free, style: { textAlign: "center" }, sortingField: "availability" },
          { value: stat.approved, style: { textAlign: "center" }, sortingField: "approved" },
        ],
      }));
    case "capacity":
      return stats[0].map((stat) => ({
        style: { height: "40px" },
        cells: [
          { value: "user_block", user: stat.user },
          { value: stat.working_days, style: { textAlign: "center" }, sortingField: "working_hours" },
          { value: stat.billable, style: { textAlign: "center" }, sortingField: "billable" },
          { value: stat.non_billable, style: { textAlign: "center" }, sortingField: "non_billable" },
          { value: stat.time_off, style: { textAlign: "center" }, sortingField: "time_off" },
          { value: stat.free, style: { textAlign: "center" }, sortingField: "availability" },
        ],
      }));
    case "compare":
      if (stats.length < 2) return [];

      return stats[0].map((stat, index) => {
        const actualsStat = stats[1][index];

        const plannedBillable = stat.billable + stat.tentative_billable;
        const actualsBillable = actualsStat.billable + actualsStat.tentative_billable;
        const plannedNonBillable = stat.non_billable + stat.tentative_non_billable;
        const actualsNonBillable = actualsStat.non_billable + actualsStat.tentative_non_billable;
        const plannedTimeOff = stat.time_off + stat.tentative_time_off;
        const actualsTimeOff = actualsStat.time_off + actualsStat.tentative_time_off;

        const plannedTotal = plannedBillable + plannedNonBillable + plannedTimeOff;
        const actualsTotal = actualsBillable + actualsNonBillable + actualsTimeOff;

        return {
          style: { height: "40px" },
          cells: [
            { value: "user_block", user: stat.user },
            { value: stat.working_hours, style: { textAlign: "center" }, sortingField: "working_hours" },
            {
              value: plannedBillable,
              style: { textAlign: "center", borderRight: 0 },
              sortingField: "planned_billable",
            },
            { value: actualsBillable, style: { textAlign: "center", borderRight: 0 }, sortingField: "actual_billable" },
            { value: plannedBillable - actualsBillable, style: { textAlign: "center" }, sortingField: "diff_billable" },
            {
              value: plannedNonBillable,
              style: { textAlign: "center", borderRight: 0 },
              sortingField: "planned_non_billable",
            },
            {
              value: actualsNonBillable,
              style: { textAlign: "center", borderRight: 0 },
              sortingField: "actual_non_billable",
            },
            {
              value: plannedNonBillable - actualsNonBillable,
              style: { textAlign: "center" },
              sortingField: "diff_non_billable",
            },
            { value: plannedTimeOff, style: { textAlign: "center", borderRight: 0 }, sortingField: "planned_time_off" },
            { value: actualsTimeOff, style: { textAlign: "center", borderRight: 0 }, sortingField: "actual_time_off" },
            { value: plannedTimeOff - actualsTimeOff, style: { textAlign: "center" }, sortingField: "diff_time_off" },
            { value: plannedTotal, style: { textAlign: "center", borderRight: 0 }, sortingField: "planned_total" },
            { value: actualsTotal, style: { textAlign: "center", borderRight: 0 }, sortingField: "actual_total" },
            { value: plannedTotal - actualsTotal, style: { textAlign: "center" }, sortingField: "difference" },
          ],
        };
      });
  }
};
